'use client'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { NotificationType } from '@/types/common/notification'
import { useRouter } from 'next/navigation'

// エラー案内文
let guideMsg =
  'エラーが発生しました。エラー情報を管理者へ連絡・お問い合わせください。'

// 固定エラーメッセージ
const defaultMsg = '予期しないエラーが発生しました'

/**
 * レスポンスヘッダ名称対応表
 * key: レスポンスヘッダ内のキー名, displayKey: 画面表示時の名称
 */
const headerKey = [
  { key: 'x-amz-apigw-id', displayKey: 'EA01' },
  { key: 'x-amzn-requestid', displayKey: 'ER01' },
  { key: 'x-amzn-errortype', displayKey: 'ET01' },
]

/**
 * エラーコードからエラー文を決定する
 * @param error
 * @returns
 */
const createMsgFromCode = (error: any) => {
  const code = error.response.status

  if (code === 400) {
    return error.response.data.details[0].message
  }
  // APIの権限が無い場合
  if (code === 403 && error.response?.data.code === 'E003') {
    guideMsg = '利用する権限がありません。管理者へ連絡・お問い合わせください。'
    return '[' + error.response?.data.code + ']' + '権限エラーです'
  }

  return defaultMsg
}

/**
 * エラー文に画面表示するヘッダ情報を付加する
 * @param error
 * @returns
 */
const createMsgHeadersInfo = (error: any) => {
  let headerInfoText = ''
  const headers = error.response.headers
  if (headers) {
    headerKey
      .map((param) => {
        const keyName = param.key.toLowerCase()
        if (headers[keyName]) {
          headerInfoText +=
            '\n[' + param.displayKey + ']: ' + headers[param.key]
        }
      })
      .filter((e) => e)
  }

  return headerInfoText
}

/**
 * エラー表示する
 * @param error
 * @param setNotification
 * @param message ocp: undefined, otd: string
 *  // 決済照合の場合、APIから取得したエラーメッセージを表示
 *  // 適時開示の場合、フロントで設定したメッセージを表示(displayMsg)
 */
export const useNoticeError = ({
  error,
  setNotification,
  message,
}: {
  error: any
  setNotification: Dispatch<SetStateAction<NotificationType>>
  message?: string
}) => {
  const router = useRouter()

  useEffect(() => {
    if (error) {
      try {
        if (!error.response) throw ''

        // Errorレスポンス内のCODEが下記に該当時はメンテ画面へ遷移
        if (error.response?.data.code === 'E004') {
          router.replace('/maintenance')
          return
        }

        // 決済照合の場合、APIから取得したエラーメッセージを表示
        // 適時開示の場合、フロントで設定したメッセージを表示(displayMsg)
        const msg = message ? message : createMsgFromCode(error)
        const headerInfo = createMsgHeadersInfo(error)

        setNotification({
          open: true,
          severity: 'error',
          msg: headerInfo === '' ? msg : guideMsg + '\n\n' + msg + headerInfo,
        })
      } catch (e) {
        setNotification({
          open: true,
          severity: 'error',
          msg: defaultMsg,
        })
      }
    }
  }, [error])
}
